export default {
  idManager: {
    viewTitle: "ID Manager",
    tabTitle: "IdManager",
  },
};
